import React from "react";
import { AlertBox } from "../../../../../shared/AlertBox/AlertBox";
import styles from "./styles.module.scss";

export const USED_IN_PACKAGES_ALERT_TYPE = {
  delete: "delete",
  inactivate: "inactivate",
};

const MESSAGE_BY_TYPE = {
  [USED_IN_PACKAGES_ALERT_TYPE.delete]:
    "This product is currently being used in the following items. Please remove all references before deleting it.",
  [USED_IN_PACKAGES_ALERT_TYPE.inactivate]:
    "This product is currently being used in the following items. Please remove all references before inactivating it.",
};

export function UsedInPackagesAlert({ usedInPackages, type }) {
  if (
    !usedInPackages ||
    (!usedInPackages.charting?.length &&
      !usedInPackages.discount?.length &&
      !usedInPackages.patientPackages?.length &&
      !usedInPackages.patientTreatmentPlans?.length &&
      !usedInPackages.invoices?.length &&
      !usedInPackages.membershipTiers?.length)
  ) {
    return null;
  }

  return (
    <AlertBox closable size="small" variant="error" className="m-t-10">
      <h4>
        {MESSAGE_BY_TYPE[type] ||
          MESSAGE_BY_TYPE[USED_IN_PACKAGES_ALERT_TYPE.delete]}
      </h4>
      <br />
      <div className={styles.content}>
        {usedInPackages?.charting?.length > 0 && (
          <div>
            <h5>Pricing Variation</h5>
            <ul className="m-l-20">
              {usedInPackages.charting.map((x) => (
                <li key={x}>{x}</li>
              ))}
            </ul>
          </div>
        )}
        {usedInPackages?.discount?.length > 0 && (
          <div>
            <h5>Promotions</h5>
            <ul className="m-l-20">
              {usedInPackages.discount.map((x) => (
                <li key={x}>{x}</li>
              ))}
            </ul>
          </div>
        )}
        {usedInPackages?.patientPackages?.length > 0 && (
          <div>
            <h5>Patient Packages</h5>
            <ul className="m-l-20">
              {usedInPackages.patientPackages.map((x) => (
                <li key={x}>{x}</li>
              ))}
            </ul>
          </div>
        )}
        {usedInPackages?.patientTreatmentPlans?.length > 0 && (
          <div>
            <h5>Patient Treatment Plans</h5>
            <ul className="m-l-20">
              {usedInPackages.patientTreatmentPlans.map((x) => (
                <li key={x}>{x}</li>
              ))}
            </ul>
          </div>
        )}
        {usedInPackages?.invoices?.length > 0 && (
          <div>
            <h5>Invoices</h5>
            <ul className="m-l-20">
              {usedInPackages.invoices.map((x) => (
                <li key={x}>{x}</li>
              ))}
            </ul>
          </div>
        )}
        {usedInPackages?.membershipTiers?.length > 0 && (
          <div>
            <h5>Memberships</h5>
            <ul className="m-l-20">
              {usedInPackages.membershipTiers.map((x) => (
                <li key={x}>{x}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </AlertBox>
  );
}
